/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(162);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(159);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(167);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(347);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(295);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(191);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(349);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(201);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _shopify_theme_addresses__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(341);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }






























function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


var SELECTORS = {
  container: '[data-register-container]',
  countryWrapper: '[data-countries-wrapper]',
  firstnameInput: '#FirstName',
  lastnameInput: '#LastName',
  emailInput: '#Email',
  passwordInput: '#CreatePassword',
  passwordLengthError: '[data-password-error]',
  birthDayInput: '#birth_day',
  birthMonthInput: '#birth_month',
  form: 'form',
  submitButton: '[type="submit"]',
  noLabelsFix: '[data-nolabel-fix]',
  birthdayHiddenInput: '[data-birthday]',
  birthdayHiddenInputTag: '[data-tags]',
  phoneInput: '#Phone',
  countryValue: '#AddressCountry'
};
var FORM_KEYS = {
  email: 'customer[email]',
  firstName: 'customer[first_name]',
  lastName: 'customer[last_name]',
  password: 'customer[password]',
  countryCode: 'country_code',
  birthDay: 'birth_day',
  birthMonth: 'birth_month',
  phone: 'customer[phone]'
};
var INVALID_DATES = ['30-02', '31-02', '31-04', '31-06', '31-09', '31-11'];
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector(SELECTORS.container);
  populateCountries(container); // addFormSubmission(container);

  prefillEmail(container);
  populateHiddenBirthday(container);
  listenCountryChange(container);
});
/**
 * @function addFormSubmission - validate and send to Klaviyo before proceeding to
 * shopify form submission.
 *
 * @param {Element} container - base element all further selector queries
 */

function addFormSubmission(container) {
  var form = container.querySelector(SELECTORS.form);
  form.addEventListener('submit', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      var _map, _map2, passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput, requiredInputs, submitButton;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              form.removeAttribute("onsubmit");
              _map = [SELECTORS.passwordInput, SELECTORS.passwordLengthError, SELECTORS.birthDayInput, SELECTORS.birthMonthInput, SELECTORS.phoneInput, SELECTORS.countryValue, SELECTORS.firstnameInput, SELECTORS.lastnameInput, SELECTORS.emailInput].map(function (selector) {
                return container.querySelector(selector);
              }), _map2 = _toArray(_map), passwordInput = _map2[0], passwordLengthError = _map2[1], dayInput = _map2[2], monthInput = _map2[3], phoneInput = _map2[4], countryInput = _map2[5], requiredInputs = _map2.slice(6);
              showOrHideValidations(requiredInputs, passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput);

              if (!formIsValid(requiredInputs, passwordInput, dayInput, monthInput, phoneInput, countryInput)) {
                _context.next = 14;
                break;
              }

              console.log("isValid");
              submitButton = container.querySelector(SELECTORS.submitButton);
              submitButton.setAttribute('disabled', true);
              submitButton.innerText = 'Joining the Beach Club...';
              _context.next = 11;
              return sendToKlaviyo(container.dataset.klaviyoCustomerListId, form);

            case 11:
              form.submit();
              _context.next = 16;
              break;

            case 14:
              event.preventDefault();
              console.log("no submit");

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  form.addEventListener('change', function (event) {
    var requiredInputs = [SELECTORS.firstnameInput, SELECTORS.lastnameInput, SELECTORS.emailInput, SELECTORS.passwordInput].map(function (selector) {
      return container.querySelector(selector);
    });

    if (allMandatoryFields(requiredInputs)) {
      form.querySelector('[type="submit"]').removeAttribute("disabled");
    } else {
      form.querySelector('[type="submit"]').setAttribute("disabled", true);
    }
  });
}
/**
 * @function sendToKlaviyo - Before submitting the registration to Shopify we
 * attempt to add the customer to the Klaviyo with custom attributes not stored
 * by shopify.
 *
 * @param {string}  listId     - which subscriber list are we sending this too?
 * @param {Element} form       - form element
 * @param {number}  retryCount - defaults to 0. We'll try up to three times to send this to Klaviyo.
 *
 * @reurns {void}
 */


function sendToKlaviyo(_x2, _x3) {
  return _sendToKlaviyo.apply(this, arguments);
}
/**
 * @function reportKlaviyoSubmissionFailure - adds a note to the customer
 * regarding the failure to create a Klaviyo record
 *
 * @param {Element} form
 * @param {FormData} formData
 */


function _sendToKlaviyo() {
  _sendToKlaviyo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(listId, form) {
    var retryCount,
        formData,
        response,
        note,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retryCount = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 1;
            formData = Object.fromEntries(new FormData(form));

            if (listId) {
              _context2.next = 6;
              break;
            }

            console.log('no list ID');
            reportKlaviyoSubmissionFailure(form, formData);
            return _context2.abrupt("return");

          case 6:
            _context2.prev = 6;
            _context2.next = 9;
            return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'cache-control': 'no-cache'
              },
              body: new URLSearchParams(Object.entries({
                g: listId,
                email: formData[FORM_KEYS.email],
                phone_number: formatPhoneNumber(formData[FORM_KEYS.phone], formData[FORM_KEYS.countryCode]),
                // pass in additional fields
                $fields: '$source, $first_name, $last_name, $birthday, $countryCode, $phone',
                $source: 'Account Creation',
                $first_name: formData[FORM_KEYS.firstName],
                $last_name: formData[FORM_KEYS.lastName],
                $birthday: formatBirthday(formData),
                $countryCode: formData[FORM_KEYS.countryCode]
              })).toString()
            });

          case 9:
            response = _context2.sent;
            _context2.next = 16;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](6);
            console.log("error", _context2.t0);
            window.console.error(_context2.t0);

          case 16:
            if (!(!response || !response.ok)) {
              _context2.next = 23;
              break;
            }

            if (!(retryCount < 3)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 20;
            return sendToKlaviyo(listId, form, retryCount + 1);

          case 20:
            _context2.next = 23;
            break;

          case 22:
            reportKlaviyoSubmissionFailure(form, formData);

          case 23:
            if (formData[FORM_KEYS.phone].length > 0) {
              note = document.createElement('input');
              note.setAttribute('name', 'customer[note][phone]');
              note.style.display = 'none';
              note.setAttribute('value', "".concat(formatPhoneNumber(formData[FORM_KEYS.phone], formData[FORM_KEYS.countryCode])));
              form.appendChild(note);
            }

            console.log(formData);

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 12]]);
  }));
  return _sendToKlaviyo.apply(this, arguments);
}

function reportKlaviyoSubmissionFailure(form, formData) {
  var note = document.createElement('input');
  var tags = document.createElement('input');
  note.setAttribute('name', 'customer[note][signup_error]');
  tags.setAttribute('name', 'customer[tags]');
  note.style.display = 'none';
  tags.style.display = 'none';
  note.setAttribute('value', "This customer was unsuccessfully submitted to Klaviyo with the following additional information: \n ".concat(formatBirthday(formData) && "- $birthday: ".concat(formatBirthday(formData)), " \n - $countryCode: ").concat(formData[FORM_KEYS.countryCode]));
  tags.setAttribute('value', "DOB:".concat(formatBirthday(formData, '/')));
  form.appendChild(note);
  form.appendChild(tags);
}
/**
 * @function showOrHideValidations - shows/hides validations to the user
 *
 * @param {Element[]} requiredInputs - array of all inputs that must have a value
 * @param {Element}   passwordInput
 * @param {Element}   passwordLengthError
 * @param {Element}   dayInput
 * @param {Element}   monthInput
 */


function showOrHideValidations(requiredInputs, passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput) {
  // Make sure password exists and is long enough
  if (!passwordInput.value) {
    passwordInput.classList.add('input-error');
    passwordInput.nextElementSibling.classList.remove('hide');
    passwordLengthError.classList.add('hide');
  } else if (passwordInput.value.length < 5) {
    passwordInput.classList.add('input-error');
    passwordInput.nextElementSibling.classList.add('hide');
    passwordLengthError.classList.remove('hide');
  } else {
    passwordInput.classList.remove('input-error');
    passwordInput.nextElementSibling.classList.add('hide');
    passwordLengthError.classList.add('hide');
  } // tedium


  if (dayInput.value && !monthInput.value) {
    dayInput.classList.remove('input-error');
    monthInput.classList.add('input-error');
    dayInput.parentElement.nextElementSibling.classList.remove('hide');
  } else if (!dayInput.value && monthInput.value || INVALID_DATES.includes("".concat(dayInput.value, "-").concat(monthInput.value))) {
    dayInput.classList.add('input-error');
    monthInput.classList.remove('input-error');
    dayInput.parentElement.nextElementSibling.classList.remove('hide');
  } else {
    dayInput.classList.remove('input-error');
    monthInput.classList.remove('input-error');
    dayInput.parentElement.nextElementSibling.classList.add('hide');
  }

  requiredInputs.forEach(function (input) {
    if (input.value) {
      input.classList.remove('input-error');
      input.nextElementSibling.classList.add('hide');
    } else {
      input.classList.add('input-error');
      input.nextElementSibling.classList.remove('hide');
    }
  });

  if (phoneInput.value.length > 0) {
    if (validatePhone(phoneInput.value, countryInput)) {
      phoneInput.classList.remove('input-error');
      phoneInput.closest('.phone-input-container').nextElementSibling.classList.add('hide');
    } else {
      phoneInput.classList.add('input-error');
      phoneInput.closest('.phone-input-container').nextElementSibling.classList.remove('hide');
    }
  }
}
/**
 * @function formIsValid - whether the form as a whole is ready for submission.
 *
 * @param {Element[]} requiredInputs - array of all inputs that must have a value
 * @param {Element}   passwordInput
 * @param {Element}   dayInput
 * @param {Element}   monthInput
 *
 * @returns {boolean}
 */


var formIsValid = function formIsValid(requiredInputs, passwordInput, dayInput, monthInput, phoneInput, countryInput) {
  return requiredInputs.every(function (_ref2) {
    var value = _ref2.value;
    return Boolean(value);
  }) && passwordInput.value && passwordInput.value.length >= 5 && (dayInput.value && monthInput.value || !dayInput.value && !monthInput.value) && !INVALID_DATES.includes("".concat(dayInput.value, "-").concat(monthInput.value)) && (validatePhone(phoneInput.value, countryInput) || phoneInput.value.length === 0);
};

var allMandatoryFields = function allMandatoryFields(requiredInputs) {
  return requiredInputs.every(function (_ref3) {
    var value = _ref3.value;
    return Boolean(value);
  });
};
/**
 * @function populateCountries - uses shopify scripts to insert the stores
 * country list into the form DOM.
 *
 * @param {Element} container - base element all further selector queries
 */


function populateCountries(_x4) {
  return _populateCountries.apply(this, arguments);
}

function _populateCountries() {
  _populateCountries = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(container) {
    var addressFields, countryField;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            addressFields = container.querySelector(SELECTORS.countryWrapper);
            countryField = addressFields.querySelector('#AddressCountry');
            _context3.prev = 2;
            _context3.next = 5;
            return (0,_shopify_theme_addresses__WEBPACK_IMPORTED_MODULE_28__.AddressForm)(addressFields, window.theme.locale.isoCode, {
              shippingCountriesOnly: addressFields.dataset.limitCountries === 'true',
              inputSelectors: {
                country: '#AddressCountry',
                // shopify scripts blow up if an element with labels property isn't found ):.
                lastName: SELECTORS.noLabelsFix,
                firstName: SELECTORS.noLabelsFix,
                company: SELECTORS.noLabelsFix,
                address1: SELECTORS.noLabelsFix,
                address2: SELECTORS.noLabelsFix,
                zone: SELECTORS.noLabelsFix,
                postalCode: SELECTORS.noLabelsFix,
                city: SELECTORS.noLabelsFix,
                phone: SELECTORS.noLabelsFix
              }
            });

          case 5:
            // If user's country couldn't be selected in dropdown (blank dropdown)
            if (!countryField.value) {
              populateCountriesFallback(countryField);
            } // If country couldn't be selected in dropdown (undefined country error)


            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](2);
            populateCountriesFallback(countryField);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 8]]);
  }));
  return _populateCountries.apply(this, arguments);
}

function populateCountriesFallback(countryField) {
  if (!countryField) return; // Set the country based on the currency (i.e. US for USD)

  var fallback = countryField.dataset.fallback; // If fallback country exists in dropdown, select it

  if (_toConsumableArray(countryField.options).map(function (o) {
    return o.value;
  }).includes(fallback)) {
    countryField.value = fallback; // Otherwise select the first country in the dropdown
  } else {
    countryField.selectedIndex = 0;
  }
}

function formatBirthday(formData) {
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return "".concat(new Date().getFullYear()).concat(symbol).concat(formData[FORM_KEYS.birthMonth]).concat(symbol).concat(formData[FORM_KEYS.birthDay]);
}

function populateHiddenBirthday(container) {
  var form = container.querySelector(SELECTORS.form);
  var birthDayInput = form.querySelector(SELECTORS.birthDayInput);
  var birthMonthInput = form.querySelector(SELECTORS.birthMonthInput);
  var birthdayHiddenInput = form.querySelector(SELECTORS.birthdayHiddenInput);
  var birthdayHiddenInputTag = form.querySelector(SELECTORS.birthdayHiddenInputTag);
  var birthDayNumber;
  var birthMonthNumber;
  form.addEventListener('change', function (evt) {
    if (evt.target === birthDayInput) {
      birthDayNumber = evt.target.options[evt.target.selectedIndex].value;
    }

    if (evt.target === birthMonthInput) {
      birthMonthNumber = evt.target.options[evt.target.selectedIndex].value;
    }

    if (!birthDayNumber || !birthMonthNumber) return;
    birthdayHiddenInput.value = "".concat(new Date().getFullYear(), "-").concat(birthMonthNumber, "-").concat(birthDayNumber, ",");
    birthdayHiddenInputTag.value = "DOB:".concat(new Date().getFullYear(), "-").concat(birthMonthNumber, "-").concat(birthDayNumber, ",");
  });
}

function prefillEmail(container) {
  var emailInput = container.querySelector(SELECTORS.emailInput);
  emailInput.value = getEmailFromSubForm();
}

function getEmailFromSubForm() {
  var queryString = window.location.search;
  var parameters = new URLSearchParams(queryString); // Snaffles the email added via the footer subscribe form

  var value = parameters.get('email');
  return value;
}

function validatePhone(input, country) {
  console.log(country.value);
  var regex;

  if (country.value === "AU") {
    regex = /^(?:\d{9}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if (country.value === "NZ" || country.value === "US" || country.value === "CA") {
    regex = /^(?:\d{10}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if (country.value === "SG") {
    regex = /^(?:\d{8}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if (country.value === "GB") {
    regex = /^(?:\d{10}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  }

  return regex.test(input);
}

function formatPhoneNumber(input, country) {
  input.replace(/-|\s/g, '');

  if (country === "AU") {
    return '+61' + input;
  } else if (country === "NZ") {
    return '+64' + input;
  } else if (country === "SG") {
    return '+65' + input;
  } else if (country === "US" || country === "US") {
    return '+1' + input;
  } else if (country === "GB") {
    return '+44' + input;
  }
}

function listenCountryChange(container) {
  var countrySelect = container.querySelector(SELECTORS.countryValue);
  var phoneContainer = document.querySelector(".phone-input-container");
  countrySelect.addEventListener("change", function () {
    if (countrySelect.value === "NZ") {
      phoneContainer.classList.add("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__ca");
      phoneContainer.classList.remove("phone-input-container__uk");
    } else if (countrySelect.value === "US") {
      phoneContainer.classList.add("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__ca");
      phoneContainer.classList.remove("phone-input-container__uk");
    } else if (countrySelect.value === "SG") {
      phoneContainer.classList.add("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__ca");
      phoneContainer.classList.remove("phone-input-container__uk");
    } else if (countrySelect.value === "CA") {
      phoneContainer.classList.add("phone-input-container__ca");
      phoneContainer.classList.remove("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__uk");
    } else if (countrySelect.value === "GB") {
      phoneContainer.classList.add("phone-input-container__uk");
      phoneContainer.classList.remove("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__ca");
    } else {
      phoneContainer.classList.remove("phone-input-container__sg");
      phoneContainer.classList.remove("phone-input-container__nz");
      phoneContainer.classList.remove("phone-input-container__us");
      phoneContainer.classList.remove("phone-input-container__ca");
      phoneContainer.classList.remove("phone-input-container__uk");
    }
  });
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			18: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkseafolly_theme"] = self["webpackChunkseafolly_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [28], () => (__webpack_require__(346)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;